import {
  GlobalOptionTypeFragment,
  useGlobalOptionTypesQuery,
} from "src/components/autoPopulateSelects/useGlobalOptionTypes.generated";
import { GlobalOptionTypesFilter, GlobalOptionTypeStatus } from "src/generated/graphqlTypes";

export function useGlobalOptionTypes(
  filterOverrides: GlobalOptionTypesFilter = {},
): GlobalOptionTypeFragment[] | undefined {
  const { data } = useGlobalOptionTypesQuery({
    fetchPolicy: "cache-first",
    variables: {
      filter: {
        version: [2],
        status: [GlobalOptionTypeStatus.Active],
        isPlanPackage: false,
        isPackageOptionV2: false,
        isProductOptionV2: false,
        ...filterOverrides,
      },
    },
  });
  return data?.globalOptionTypes;
}
